import { jsx as m } from "react/jsx-runtime";
import d, { useEffect as h } from "react";
import { fetchBrightcoveData as g, getVideoResourceUrl as l } from "../../lib/fetchBrightcoveData.mjs";
import { VideoPoster as v } from "../VideoPoster/VideoPoster.mjs";
/* empty css                 */
const T = ({
  accountId: r,
  policyKey: o,
  playlistId: i,
  videoId: s,
  posterUrl: t,
  testId: u,
  onActivate: a,
  previewOnly: c = !1
}) => {
  const [n, f] = d.useState(
    t || null
  );
  return h(() => {
    t || g(
      r,
      o,
      l(s, i)
    ).then((e) => {
      e != null && e.videos && e.videos.length > 0 && f(e.videos[0].poster || null);
    }).catch(() => {
      f(null);
    });
  }, [r, o, i, s, t]), n ? /* @__PURE__ */ m("div", { className: "VideoThumbnail", "data-testid": u, children: /* @__PURE__ */ m(
    v,
    {
      posterUrl: n,
      isLoading: !1,
      isVisible: !0,
      onActivate: a || (() => {
      }),
      instanceLabel: "",
      errorMessage: "",
      previewOnly: c
    }
  ) }) : null;
};
export {
  T as VideoThumbnail
};
//# sourceMappingURL=VideoThumbnail.mjs.map
